import { memo, useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import { getIn } from '../../utils/getIn';
import UILink from 'UIComponents/link/UILink';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrentSettingsWrapper = styled.div.withConfig({
  displayName: "CurrentSettingsInfoHelpDesk__CurrentSettingsWrapper",
  componentId: "sc-589y9j-0"
})(["font-weight:", ";"], WEB_FONT_MEDIUM_WEIGHT);
const CallSettingWrapper = styled.div.withConfig({
  displayName: "CurrentSettingsInfoHelpDesk__CallSettingWrapper",
  componentId: "sc-589y9j-1"
})(["display:flex;flex-direction:column;"]);
const getUserPreferencesUrl = () => `${getFullUrlWithCurrentSubDomain()}/settings/${PortalIdParser.get()}/user-preferences/calling`;
const CurrentSettingsInfoHelpDesk = ({
  selectedCallProvider,
  onCallButtonClick
}) => {
  const providerName = useMemo(() => getIn(['name'], selectedCallProvider), [selectedCallProvider]);
  const onChangeProviderClick = useCallback(() => {
    onCallButtonClick();
  }, [onCallButtonClick]);
  return selectedCallProvider ? /*#__PURE__*/_jsx(CurrentSettingsWrapper, {
    children: /*#__PURE__*/_jsxs(CallSettingWrapper, {
      className: "p-x-4 p-y-3",
      "data-selenium-test": "selected-third-party-help-desk-provider",
      children: [providerName, /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: getUserPreferencesUrl(),
        onClick: onChangeProviderClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "thirdPartyHelpDeskPopover.changeCallingProvider"
        })
      })]
    })
  }) : null;
};
export default /*#__PURE__*/memo(CurrentSettingsInfoHelpDesk);